import React, { createContext, useContext } from 'react';
import PropTypes from 'prop-types';

import useBulkDeployPageContextProps from './useBulkDeployPageContextProps';

const BulkDeployPageContext = createContext({});

function useBulkDeployPageContext() {
  return useContext(BulkDeployPageContext);
}

function BulkDeployPageContextProvider({ children }) {
  const contextValue = useBulkDeployPageContextProps();

  return <BulkDeployPageContext.Provider value={contextValue}>{children}</BulkDeployPageContext.Provider>;
}

BulkDeployPageContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export { BulkDeployPageContextProvider, useBulkDeployPageContext };
